<!--编辑设备-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">{{ $route.params.id ? "编辑设备" : "新增设备" }}</span>
      </div>
    </div>

    <div class="machine_box">
      <div class="item_title">基本信息</div>
      <Form
        ref="formInline1"
        :model="data"
        :rules="rule"
        style="margin-left: 30px; margin-top: 20px"
        :label-width="100"
      >
        <!--  <FormItem prop="machine_type" label="设备类型:">
          <ButtonGroup class="meter-group">
            <Button @click="setMeter(0)" :type="data.meter === 0 ? 'primary' : 'default'"
              >云知印</Button
            >
            <Button @click="setMeter(3)" :type="data.meter === 3 ? 'primary' : 'default'"
              >云知印mini</Button
            >
            <Button @click="setMeter(1)" :type="data.meter === 1 ? 'primary' : 'default'"
              >智能运维</Button
            >
          </ButtonGroup>
        </FormItem> -->
        <FormItem prop="machine_type_id" label="设备型号:">
          <Select
            :disabled="data.meter === ''"
            v-model="data.machine_type_id"
            placeholder="请选择，或输入设备型号检索"
            style="width: 300px"
            filterable
          >
            <Option v-for="(item, index) in type" :value="item.id" :key="index">{{
              item.brand + " - " + item.name
            }}</Option>
          </Select>
        </FormItem>

        <!-- <FormItem prop="color" label="色彩设定:">
        <Select :disabled="data.meter === ''" v-model="data.color" style="width: 300px;">
          <Option v-for="(item,index) in color" :value="item" :key="index">{{item}}</Option>
        </Select>
          </FormItem>-->

        <FormItem prop="sn" label="设备序列号:">
          <Input
            :disabled="data.meter === '' || (data.id ? true : false)"
            v-model="data.sn"
            style="width: 300px"
            placeholder="请输入设备序列号"
          />
          <div class="describe">输入错误将影响设备与服务器的连接，序列号不支持修改</div>
        </FormItem>

        <FormItem prop="agent_id" label="合作伙伴:" v-if="!user.tp && agentAccess()">
          <Tooltip content="修改此项将在设备重连后生效" placement="top">
            <Select
              :disabled="data.meter === ''"
              v-model="data.agent_id"
              filterable
              style="width: 300px"
              @on-change="agentChange"
            >
              <Option v-for="(item, index) in agent" :value="item.id" :key="index">{{
                user.id === item.id ? "自营" : item.agent_name
              }}</Option>
            </Select>
          </Tooltip>
        </FormItem>

        <FormItem prop="company_id" label="关联学校:">
          <Tooltip content="修改此项将在设备重连后生效" placement="top">
            <Select
              :disabled="data.meter === ''"
              v-model="data.company_id"
              style="width: 300px"
              filterable
              placeholder="请选择，或输入学校名称关键字检索"
            >
              <!-- <Option :value="0">自营</Option> -->
              <Option
                v-for="(item, index) in company"
                :value="item.id"
                :key="index"
                v-if="item.agent_id === data.agent_id"
                >{{ item.name }}</Option
              >
              <!-- <Option key="new" :value="0" style="padding: 0">
                <div
                  style="color: #2b85e4; padding: 7px 16px"
                  @click="new_company"
                >
                  新增学校
                </div>
                  </Option> -->
            </Select>
          </Tooltip>
          <!-- <div class="describe">
            关联后，学校管理员可通过后台和手机端查看设备状态、印量报表
              </div> -->
        </FormItem>

        <!-- <FormItem
          prop="charge_id"
          label="计费方案:"
          v-if="data.meter == 0 || data.meter == 3"
        >
          <Select
            :disabled="data.meter === ''"
            v-model="data.charge_id"
            placeholder="请选择"
            style="width: 300px"
            filterable
          >
            <Option
              v-for="(item, index) in charge"
              :value="item.id"
              :key="index"
              v-if="item.agent_id === data.agent_id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem> -->
        <FormItem prop="repair_ids" label="维护人员:">
          <Select
            :disabled="data.meter === ''"
            v-model="data.repair_ids"
            style="width: 300px"
            placeholder="请选择"
            multiple
            filterable
          >
            <Option
              v-for="(item, index) in repair"
              :value="item.id"
              :key="index"
              v-if="item.agent_id == data.agent_id"
              >{{ item.name }}</Option
            >
            <!-- <Option
              v-for="(item, index) in repair"
              :value="item.id"
              :key="index"
              :disabled="!item.gzh_openid"
              v-if="item.agent_id == data.agent_id"
              >{{ item.name }}{{ !item.gzh_openid ? "(未激活)" : "" }}</Option
            > -->
            <!--  <Option key="new" :value="0" style="padding: 0">
              <div style="color: #2b85e4; padding: 7px 16px" @click="newRepair()">
                新增维护人员
              </div>
                </Option> -->
          </Select>
          <span
            @click="newRepair()"
            style="cursor: pointer; padding-left: 10px; color: rgb(45, 140, 240)"
            >新增维护人员</span
          >
          <!-- <div class="describe">
            未激活的维护人员不能被选择，被关联的维护人员，将会收到设备的异常通知
          </div> -->
        </FormItem>

        <FormItem prop="site_id" label="设备站点:">
          <Tooltip content="修改此项将在设备重连后生效" placement="top">
            <Select
              :disabled="data.meter === ''"
              v-model="data.site_id"
              style="width: 300px"
              placeholder="请选择，或输入站点名称关键字检索"
              filterable
            >
              <Option
                v-for="(item, index) in site"
                :value="item.id"
                :key="index"
                v-if="item.agent_id === data.agent_id"
                >{{ item.name }}</Option
              >
              <Option key="new" :value="0" style="padding: 0">
                <div style="color: #2b85e4; padding: 7px 16px" @click="newSite()">
                  新建站点
                </div>
              </Option>
            </Select>
          </Tooltip>
          <div class="describe">
            代表设备所在地方的简称，如：重庆大学图书馆、西南医院第3住院部
          </div>
        </FormItem>
        <!-- <FormItem
          prop="scene_id"
          label="场景类型:"
          v-if="data.meter === 0 || data.meter === 3"
        >
          <Select
            :disabled="data.meter === ''"
            v-model="data.scene_id"
            style="width: 300px"
            filterable
          >
            <Option v-for="(item, index) in scene" :value="item.id" :key="index">{{
              item.name
            }}</Option>
          </Select>
        </FormItem> -->

        <FormItem prop="al" label="设备地址:">
          <div class="item_addres">
            <al-selector
              :gutter="0"
              :disabled="data.meter === ''"
              ref="al"
              style="width: 500px; display: inline-block"
              data-type="name"
              searchable
              v-model="data.al"
              level="2"
            />
            <Input
              style="margin-left: 10px; width: 300px"
              v-model="data.address"
              placeholder="详细地址（请勿重复填入省市区）"
            />
          </div>
        </FormItem>
        <FormItem prop="address_detail" label="摆放位置:">
          <Input
            :disabled="data.meter === ''"
            v-model="data.address_detail"
            placeholder="请输入设备摆放位置"
            style="width: 300px"
          />
          <div class="describe">如：前台、茶水间、服务区</div>
        </FormItem>

        <FormItem prop="mono_happed" label="初始计数:">
          黑白
          <Input
            :disabled="data.color_happed >= 0 && data.mono_happed >= 0 && machine_id"
            v-model="data.mono_happed"
            placeholder="请输入设备摆放位置"
            style="width: 200px"
            type="number"
          />
          彩色
          <Input
            :disabled="data.color_happed >= 0 && data.mono_happed >= 0 && machine_id"
            v-model="data.color_happed"
            placeholder="请输入设备摆放位置"
            type="number"
            style="width: 200px"
          />
          <div class="describe">
            请填入设备在云打印平台建档时，设备的印张计数器，全新机填入0，错误填写可能影响设备印量统计
          </div>
        </FormItem>
        <!-- <FormItem prop="meter_date" label="自动抄表:" v-if="data.meter !== 2">
          <div>
            <Tooltip
              :content="data.meter_date ? '是否关闭智能运维' : '是否开启智能运维'"
              placement="top"
            >
              <i-switch
                v-model="data.meter_date"
                size="large"
                :disabled="data.meter === ''"
                :true-value="1"
                :false-value="0"
              >
                <span slot="open">开启</span>
                <span slot="close">关闭</span>
              </i-switch>
            </Tooltip>
            <Tooltip content="抄表日期" placement="top">
              <Select
                v-if="data.meter_date"
                placeholder="结算日期"
                :disabled="data.meter === ''"
                v-model="data.meter_date"
                style="width: 100px; margin-left: 10px"
              >
                <Option v-for="i in 28" :key="i" :value="i">{{ i }}号</Option>
              </Select>
            </Tooltip>
          </div>
          <div class="describe">
            系统将自动在设定的抄表日期向设备远程抓取印张数据，开启后，系统默认每月1号自动抄表
          </div>
        </FormItem> -->

        <!-- <FormItem prop="meter_charge_id" label="抄表结算方案:">
          <Select
            placeholder="结算方案"
            :disabled="data.meter === ''"
            v-model="data.meter_charge_id"
            style="width: 300px"
            filterable
          >
            <Option
              v-for="(item, index) in meter_charge"
              :value="item.id"
              :key="index"
              v-if="item.agent_id === data.agent_id"
              >{{ item.name }}</Option
            >
          </Select>
          <div class="describe">通过抄表结算方案，可自动为设备生成抄费费用结算单</div>
        </FormItem> -->
      </Form>
      <!-- <div class="pageTitle" v-if="data.meter == 0 || data.meter == 3">
        服务内容
        <span style="color: #999; font-size: 12px; margin-left: 15px; font-weight: normal"
          >服务内容只作为内容展示，如需进行功能控制请在“使用限制”中设置</span
        >
      </div> -->
      <!--  <Form
        ref="formInline2"
        :model="data"
        :rules="rule"
        style="margin-left: 30px; margin-top: 20px"
        v-if="data.meter == 0 || data.meter == 3"
        :label-width="100"
      > -->
      <!--  <FormItem prop="is_share" label="设备共享:">
          <i-switch
            v-model="data.is_share"
            size="large"
            :disabled="data.meter === ''"
            :true-value="1"
            :false-value="0"
          >
            <span slot="open">开启</span>
            <span slot="close">关闭</span>
          </i-switch>
          <div class="describe">
            此设备是否支持外来人员使用，如设备在学校内部，只供内部员工使用，便可关闭此项
          </div>
        </FormItem> -->
      <!-- <FormItem prop="support" label="设备支持:">
          <div style="width: 510px">
            <CheckboxGroup v-model="data.support">
              <Checkbox
                v-for="(item, index) in support"
                :key="index"
                :label="item"
                :disabled="data.meter === ''"
              >
              </Checkbox>
            </CheckboxGroup>
          </div>
          <div class="describe">
            向消费者展示设备可提供哪些功能服务，方便选择使用站点，并无功能控制作用
          </div>
        </FormItem> -->
      <!-- <FormItem label="营业时间:">
          <div style="width: 300px">
            <Tooltip placement="top">
              <span class="service">默认:08:30-21:00</span>
              <div slot="content">
                <p>周一: {{ data.service_mon }}</p>
                <p>周二: {{ data.service_tues }}</p>
                <p>周三: {{ data.service_wed }}</p>
                <p>周四: {{ data.service_thur }}</p>
                <p>周五: {{ data.service_fri }}</p>
                <p>周六: {{ data.service_sat }}</p>
                <p>周日: {{ data.service_sun }}</p>
              </div>
            </Tooltip>
            <span
              v-if="data.meter !== ''"
              class="text-button"
              @click="service_visible = true"
              >修改</span
            >
          </div>
          <div class="describe">向消费者展示设备可提供服务的时间段</div>
        </FormItem> -->
      <!-- <FormItem prop="map" label="地图显示:">
          <div style="width: 300px">
            <span class="map">{{ data.lng && data.lat ? "已设置" : "未设置" }}</span>
            <span v-if="data.meter !== ''" class="text-button" @click="openMap"
              >设置</span
            >
          </div>
          <div class="describe">
            消费者可在微信小程序和云知印手机APP中查看到设备在地图中的位置，方便前往
          </div>
        </FormItem> -->
      <!-- </Form> -->
      <!--  <div class="pageTitle" v-if="data.meter == 0">
        使用限制
        <span style="color: #999; font-size: 12px; margin-left: 15px; font-weight: normal"
          >未勾选的功能在设备端无法使用</span
        >
      </div> -->
      <!--  <Form
        ref="formInline3"
        :model="data"
        :rules="rule"
        style="margin-top: 20px"
        v-if="data.meter == 0"
        :label-width="100"
      >
        <FormItem>
          <div class="limit_box">
            <div>
              <div>
                <Checkbox
                  :indeterminate="indeterminate1"
                  :value="checkAll1"
                  @click.prevent.native="handleCheckAll(1)"
                  :disabled="user.tp == 1"
                  >游客</Checkbox
                >
              </div>
              <CheckboxGroup
                v-model="checkAllGroup1"
                @on-change="checkAllGroupChange(1)"
                style="display: flex; flex-direction: column; margin-left: 20px"
              >
                <Checkbox label="print" :disabled="user.tp == 1">打印</Checkbox>
                <Checkbox label="copy" :disabled="user.tp == 1">复印</Checkbox>
                <Checkbox label="color" :disabled="user.tp == 1">彩色</Checkbox>
              </CheckboxGroup>
            </div>
            <div style="margin: 0 80px">
              <div>
                <Checkbox
                  :indeterminate="indeterminate2"
                  :value="checkAll2"
                  @click.prevent.native="handleCheckAll(2)"
                  :disabled="user.tp == 1"
                  >会员</Checkbox
                >
              </div>
              <CheckboxGroup
                v-model="checkAllGroup2"
                @on-change="checkAllGroupChange(2)"
                style="display: flex; flex-direction: column; margin-left: 20px"
              >
                <Checkbox label="print" :disabled="user.tp == 1">打印</Checkbox>
                <Checkbox label="copy" :disabled="user.tp == 1">复印</Checkbox>
                <Checkbox label="scan" :disabled="user.tp == 1">扫描</Checkbox>
                <Checkbox label="color" :disabled="user.tp == 1">彩色</Checkbox>
              </CheckboxGroup>
            </div>
            <div>
              <div>
                <Checkbox
                  :indeterminate="indeterminate3"
                  :value="checkAll3"
                  @click.prevent.native="handleCheckAll(3)"
                  :disabled="user.tp == 1"
                  >会员(学校员工)</Checkbox
                >
              </div>
              <CheckboxGroup
                v-model="checkAllGroup3"
                @on-change="checkAllGroupChange(3)"
                style="display: flex; flex-direction: column; margin-left: 20px"
              >
                <Checkbox label="print" :disabled="user.tp == 1">打印</Checkbox>
                <Checkbox label="copy" :disabled="user.tp == 1">复印</Checkbox>
                <Checkbox label="scan" :disabled="user.tp == 1">扫描</Checkbox>
                <Checkbox label="color" :disabled="user.tp == 1">彩色</Checkbox>

              </CheckboxGroup>
            </div>
          </div>
        </FormItem>
        <FormItem>
          <div style="margin-left: -20px">
            <Checkbox v-model="isCoupon"> 此设备不允许使用“优惠券”</Checkbox>
            <span style="color: #999999; font-size: 10px"
              >(只针对通用基础版设置有效)</span
            >
          </div>
          <div style="margin-left: -20px">
            <Checkbox v-model="isSelfStaff"> 此设备不允许“非本学校员工”使用</Checkbox>
            <span style="color: #999999; font-size: 10px"
              >(此项需要设备关联学校后才能生效，且只针对通用基础版设置有效)</span
            >
          </div>
          <div style="margin-left: -20px">
            <Checkbox v-model="isOpenList">
              当检测到有待打印文件时，设备端登录后直接打开打印列表页面</Checkbox
            >
            <span style="color: #999999; font-size: 10px"
              >(只针对通用基础版设置有效)</span
            >
          </div>
          <div style="margin-left: -20px">
            <Checkbox v-model="isScanPay">允许会员(学校员工)使用扫码支付功能</Checkbox>
            <span style="color: #999999; font-size: 10px"
              >开通后，当员工账户余额不足时支持通过微信或支付宝扫码付款完成作业，款项将通过分账方式支付给服务商（需保证设备端通用基础版6.0、服务窗口版7.1以上）</span
            >
          </div>
        </FormItem>
      </Form> -->
      <!-- <div class="pageTitle" v-if="data.meter == 0 || data.meter == 3">资金分账</div>
      <Form
        ref="formInline5"
        :rules="rule"
        style="margin-left: 30px; margin-top: 20px"
        v-if="data.meter == 0 || data.meter == 3"
        :label-width="100"
      >
        <FormItem prop="dispense" label="资金分账:">
          <div style="width: 300px">
            <span class="map">{{
              modalDispense.select.length ? "已设置" : "未设置"
            }}</span>
            <span v-if="data.meter !== ''" class="text-button" @click="showDispense"
              >设置</span
            >
          </div>
          <div class="describe">
            每日凌晨1点自动开始对前一天的订单进行分账，可至财务管理-分账详情了解分账进度以及到账情况
            <router-link :to="{ name: 'dispense' }">新建收款人</router-link>
          </div>
        </FormItem>
      </Form> -->

      <div class="pageTitle" v-if="data.meter == 0">其它内容</div>
      <Form
        ref="formInline4"
        :model="data"
        :rules="rule"
        style="margin-left: 30px; margin-top: 20px"
        :label-width="100"
      >
        <FormItem prop="functions" label="增值功能:" v-if="data.meter == 0">
          <CheckboxGroup v-model="data.functions">
            <Checkbox label="cardlogin" :disabled="!agentAccess()">刷卡认证功能</Checkbox>
            <!--  <Checkbox label="idcard" :disabled="!agentAccess()" style="margin-left: 15px"
              >身份证读取输出功能</Checkbox
            >

            <Checkbox label="facelogin" :disabled="!agentAccess()">面容认证功能</Checkbox>
            <Checkbox label="photo_print" :disabled="!agentAccess()"
              >相片冲印功能</Checkbox
            > -->
          </CheckboxGroup>
          <!-- <div class="describe">
            增值功能请前往应用中心购买后自动开通，<router-link :to="{ name: 'increment' }"
              >了解购买</router-link
            >
          </div> -->
        </FormItem>

        <FormItem
          prop="service_tel"
          label="服务电话:"
          v-if="(data.meter == 0 || data.meter == 3) && !user.tp"
        >
          <div style="display: flex">
            <Input
              v-model="data.service_tel"
              style="width: 300px"
              :disabled="!agentAccess()"
              placeholder="请输入设备服务电话"
            />
          </div>
          <div class="describe">
            服务电话将被展示在设备主屏幕首页,如需设置请联系云知印客服
          </div>
        </FormItem>
        <FormItem
          label="公司Logo:"
          v-if="(data.meter == 0 || data.meter == 3) && !user.tp"
        >
          <div style="display: flex">
            <div class="upload_box">
              <img v-if="data.logo" :src="data.logo" style="width: 248px; height: 38px" />
              <Tooltip
                content="推荐248px*38px"
                placement="top"
                v-if="!data.logo && agentAccess()"
              >
                <span class="upload">
                  <label for="logo" style="cursor: pointer">+ 上传Logo图片</label>
                  <input
                    type="file"
                    id="logo"
                    style="position: absolute; clip: rect(0 0 0 0)"
                    accept="image/png"
                    @change="choose($event, 0)"
                  />
                </span>
              </Tooltip>
              <Button
                type="info"
                style="margin-left: 10px"
                v-if="data.logo && agentAccess()"
                @click="data.logo = ''"
                >清空Logo</Button
              >
            </div>
          </div>
          <div class="describe">
            公司logo将被展示在设备主屏幕首页，logo大小支持248*38像素，如需设置请联系云知印客服
          </div>
        </FormItem>
        <br />
        <FormItem style="margin-left: -70px">
          <Button @click="cancelBtn" style="margin-right: 5px">取消</Button>
          <Button
            v-if="
              data.id && (data.status === 0 || data.status === 3 || data.status === 4)
            "
            @click="editMachine({ status: 2 })"
            type="error"
            style="margin-right: 5px"
            >删除</Button
          >
          <Button
            v-if="
              data.id && (data.status === 0 || data.status === 3 || data.status === 4)
            "
            @click="editMachine({ status: 1 })"
            type="warning"
            style="margin-right: 5px"
            >禁用</Button
          >
          <Button
            v-if="data.id && (data.status === 1 || data.status === 2)"
            @click="editMachine({ status: 0 })"
            type="success"
            style="margin-right: 5px"
            >恢复</Button
          >
          <Button
            type="success"
            :loading="loading"
            v-preventReClick
            @click="handleSubmit"
            :disabled="data.meter === ''"
            >确定</Button
          >
        </FormItem>
      </Form>

      <Spin fix v-if="loaded"></Spin>
    </div>

    <Modal v-model="service_visible" width="320" title="运营时间" @on-ok="serviceModalOk">
      <div class="service-inputs">
        <Row>
          <Col span="6" class="col-title">周一</Col>
          <Col span="18">
            <TimePicker
              v-model="service_mon"
              format="HH:mm"
              type="timerange"
              placement="bottom-end"
              placeholder="营业时间"
              style="width: 168px"
            ></TimePicker>
          </Col>
        </Row>
        <Row>
          <Col span="6" class="col-title">周二</Col>
          <Col span="18">
            <TimePicker
              v-model="service_tues"
              format="HH:mm"
              type="timerange"
              placement="bottom-end"
              placeholder="营业时间"
              style="width: 168px"
            ></TimePicker>
          </Col>
        </Row>
        <Row>
          <Col span="6" class="col-title">周三</Col>
          <Col span="18">
            <TimePicker
              v-model="service_wed"
              format="HH:mm"
              type="timerange"
              placement="bottom-end"
              placeholder="营业时间"
              style="width: 168px"
            ></TimePicker>
          </Col>
        </Row>
        <Row>
          <Col span="6" class="col-title">周四</Col>
          <Col span="18">
            <TimePicker
              v-model="service_thur"
              format="HH:mm"
              type="timerange"
              placement="bottom-end"
              placeholder="营业时间"
              style="width: 168px"
            ></TimePicker>
          </Col>
        </Row>
        <Row>
          <Col span="6" class="col-title">周五</Col>
          <Col span="18">
            <TimePicker
              v-model="service_fri"
              format="HH:mm"
              type="timerange"
              placement="bottom-end"
              placeholder="营业时间"
              style="width: 168px"
            ></TimePicker>
          </Col>
        </Row>
        <Row>
          <Col span="6" class="col-title">周六</Col>
          <Col span="18">
            <TimePicker
              v-model="service_sat"
              format="HH:mm"
              type="timerange"
              placement="bottom-end"
              placeholder="营业时间"
              style="width: 168px"
            ></TimePicker>
          </Col>
        </Row>
        <Row>
          <Col span="6" class="col-title">周日</Col>
          <Col span="18">
            <TimePicker
              v-model="service_sun"
              format="HH:mm"
              type="timerange"
              placement="bottom-end"
              placeholder="营业时间"
              style="width: 168px"
            ></TimePicker>
          </Col>
        </Row>
      </div>
    </Modal>

    <Modal width="80%" v-model="map_visible" title="地图设置" @on-ok="mapModalOk">
      <div>
        <div class="map-search">
          <Input
            class="map-input"
            placeholder="搜索地址"
            @on-enter="setPoint"
            v-model="map_search"
          >
            <Button slot="append" icon="ios-search" @click="setPoint"></Button>
          </Input>
        </div>
        <div class="map" ref="map"></div>
      </div>
    </Modal>

    <Modal v-model="siteObj.visible" :width="600" title="新增站点">
      <div class="tips" style="margin-bottom: 30px">
        <Icon
          type="md-alert"
          size="20"
          color="#2d8cf0"
          style="margin-right: 10px"
        />代表设备所在地方的简称，如：重庆大学图书馆、西南医院第3住院部
      </div>
      <Form :label-width="100">
        <FormItem label="站点名称:">
          <Input v-model="siteObj.name" style="width: 300px" placeholder="输入站点名称" />
        </FormItem>
        <FormItem label="站点所属:">
          <Select v-model="siteObj.agent_id" style="width: 300px" placeholder="默认自营">
            <Option :value="0">自营</Option>
            <Option v-for="(item, index) in agent" :value="item.id" :key="index">{{
              item.agent_name
            }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="siteObj.visible = false">取消</Button>
        <Button type="primary" @click="saveSiteObj()">确定</Button>
      </div>
    </Modal>

    <Modal title="新增维护人员" v-model="repairObj.visible">
      <Form
        ref="form"
        :model="repairObj.current"
        :rules="repairObj.rule"
        :label-width="80"
        width="600"
      >
        <!-- <div class="tips" style="margin-bottom: 30px">
          <Icon
            type="md-alert"
            size="20"
            color="#2d8cf0"
            style="margin-right: 10px"
          />维护人员账号新增后，必须激活后才能与设备绑定
        </div> -->
        <FormItem prop="name" label="姓名:">
          <Input v-model="repairObj.current.name" style="width: 300px" />
        </FormItem>
        <FormItem prop="tel" label="电话:">
          <Input v-model="repairObj.current.tel" style="width: 300px" />
        </FormItem>
        <FormItem prop="agent_id" label="合作伙伴:" v-if="!user.tp">
          <Select
            v-model="repairObj.current.agent_id"
            style="width: 300px"
            filterable
            placeholder="默认自营"
          >
            <!-- <Option :value="user.id">自营</Option> -->
            <Option v-for="(item, index) in agent" :key="index" :value="item.id">{{
              item.agent_name
            }}</Option>
          </Select>
        </FormItem>
        <FormItem prop="gender" label="性别:">
          <RadioGroup v-model="repairObj.current.gender">
            <Radio :label="1">男</Radio>
            <Radio :label="0">女</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="repairObj.visible = false">取消</Button>
        <Button type="primary" :loading="repairObj.loading" @click="saveRepairs"
          >确定</Button
        >
      </div>
    </Modal>
    <Modal title="新增学校" v-model="companyAdd.status" :width="700" :footer-hide="true">
      <add-company
        :is_compont="true"
        @on-change="AddCompanyCall"
        @cancel="companyAdd.status = false"
      ></add-company>
    </Modal>

    <Modal v-model="modalVerify.visible" title="负责人身份验证" :width="650" footer-hide>
      <div class="modal_verify">
        <div class="title">您正在进行敏感信息操作，为保证资金安全，请进行身份验证！</div>
        <div class="tip">
          {{
            modalVerify.isCode
              ? "验证码已发送至以下手机号，请注意查收"
              : "点击获取验证码，并正确填入"
          }}
        </div>
        <div class="tel">
          {{ modalVerify.tel }}
          <div class="getCode" v-if="!modalVerify.isCode" @click="getCode">
            获取验证码
          </div>
        </div>
        <div style="height: 130px; padding-top: 20px">
          <div class="input_box" v-if="modalVerify.isCode">
            <Input
              v-model="modalVerify.code"
              class="input"
              size="large"
              placeholder="请正确填入验证码"
            />
            <div class="confirm" @click="confirmVerify">
              确认({{ verifiy.verifiyBtnText }})
            </div>
          </div>
        </div>
      </div>
    </Modal>

    <Modal v-model="modalDispense.visible" title="设备分账设置" :width="700">
      <div class="tips">
        <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right: 10px" />
        设备与收款人关联后，即代表你同意将此设备的收益，按所设定的比例支付给此收款人；款项划拨后不可逆转，请谨慎操作！
      </div>
      <div class="dispense_box">
        <div>
          设备序列号：<span style="font-weight: bold">{{ modalDispense.sn }}</span>
        </div>
        <div style="margin-top: 26px">
          选择收款人：
          <Select
            v-model="modalDispense.data.accoun_id"
            class="select"
            style="width: 300px"
            placeholder="只能选择‘完成配置’的收款人"
          >
            <Option
              v-for="(item, index) in modalDispense.accounts"
              style="text-align: left"
              :key="index"
              :disabled="!item.user_id || item.status != 1 || item.is_del == 1"
              :value="item.id"
              >ID:{{ item.id }}&nbsp;&nbsp;{{ item.name
              }}{{
                item.is_del == 0
                  ? !item.user_id || item.status != 1
                    ? "(未配置)"
                    : ""
                  : "(已禁用)"
              }}</Option
            >
          </Select>

          <Button style="margin-left: 15px" v-preventReClick @click="addAccount"
            >确定</Button
          >
        </div>
        <div style="margin-top: 15px" v-if="modalDispense.dispense.length > 0">
          <table class="ivu-table ivu-table-default appoint-table" style="width: 100%">
            <tr>
              <th>收款ID</th>
              <th style="width: 150px">收款人</th>
              <th>分账比例</th>
              <th style="width: 130px; text-align: center">操作</th>
            </tr>
            <tr v-for="(item, index) in modalDispense.dispense" :key="index">
              <td>{{ item.dispense_account_id }}</td>
              <td style="width: 150px">
                {{ item.name }}
              </td>
              <td>
                <div style="display: flex; align-items: center">
                  <Input
                    placeholder="如分账比例是100%，则填入数字“100”"
                    v-model="item.extract"
                    :min="1"
                    :max="100"
                    maxlength="3"
                    type="number"
                    number
                  >
                  </Input>
                  <span>%</span>
                </div>
              </td>
              <td style="width: 130px; text-align: center">
                <span class="del" @click="remove(item, index)">删除</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button @click="modalDispense.visible = false">取消</Button>
        <Button v-preventReClick type="primary" @click="saveDisppence(false)"
          >确定</Button
        >
      </div>
    </Modal>

    <machine-dispense
      v-model="machineDispenseParams.visible"
      :machine="machineDispenseParams.machine"
      @cancel="machineDispenseParams.visible = false"
    ></machine-dispense>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { hasOneOf } from "@/libs/tools";
import addCompany from "../../company/update";
import machineDispense from "../machineDispense";

export default {
  components: {
    addCompany,
    machineDispense,
  },
  data() {
    const mapValidator = (rule, value, callback) => {
      callback();
      return;
      if (!this.lng && !this.lat) {
        callback(new Error("请标注地图位置"));
      } else {
        callback();
      }
    };
    const dispenseValidator = (rule, value, callback) => {
      callback();
      return;
      console.log("dispenseValidator", this.modalDispense.select.length);
      if (!this.modalDispense.select.length) {
        callback(new Error("请设置资金分账"));
      } else {
        callback();
      }
    };
    this.lng = 0;
    this.lat = 0;
    this.service_mon = ["08:30", "21:00"];
    this.service_tues = ["08:30", "21:00"];
    this.service_wed = ["08:30", "21:00"];
    this.service_thur = ["08:30", "21:00"];
    this.service_fri = ["08:30", "21:00"];
    this.service_sat = ["08:30", "21:00"];
    this.service_sun = ["08:30", "21:00"];
    return {
      loading: false,
      data: {
        agent_id: 0,
        al: [],
        meter: 0,
        is_share: 0,
        lng: 0,
        lat: 0,
        service_mon: "08:30-21:00",
        service_tues: "08:30-21:00",
        service_wed: "08:30-21:00",
        service_thur: "08:30-21:00",
        service_fri: "08:30-21:00",
        service_sat: "08:30-21:00",
        service_sun: "08:30-21:00",
        functions: ["cardlogin"],
        support: ["会员", "打印", "复印", "扫描", "A3", "彩色"],
        service_tel: "",
        logo: "",
        repair_ids: [],
        mono_happed: 0,
        color_happed: 0,
      },
      indeterminate1: false,
      indeterminate2: false,
      indeterminate3: false,
      checkAll1: true,
      checkAll2: true,
      checkAll3: true,
      checkAllGroup1: ["print", "copy", "color"],
      checkAllGroup2: ["print", "copy", "scan", "color"],
      checkAllGroup3: ["print", "copy", "scan", "color"],
      isCoupon: false, //是否可以使用优惠券
      isSelfStaff: false, //是否可以本学校使用
      isOpenList: false, //是否可以显示打印界面
      isScanPay: false, //是否可以扫码支付
      permission: ["print", "copy", "scan", "color"],
      service_tel: "",
      rule: {
        machine_type_id: [
          {
            required: true,
            type: "number",
            message: "请选择设备型号",
            trigger: "select",
          },
        ],
        company_id: [
          {
            required: true,
            type: "number",
            message: "请选择学校",
            trigger: "select",
          },
        ],
        // color: [{ required: true, message: '请选择色彩设定', trigger: 'blur' }],
        sn: [{ required: true, message: "请输入设备序列号", trigger: "blur" }],
        al: [
          {
            required: true,
            type: "array",
            min: 2,
            message: "请选择设备地址",
            trigger: "blur",
          },
        ],
        address: [{ required: true, message: "请输入设备地址", trigger: "blur" }],
        address_detail: [{ required: true, message: "请输入摆放位置", trigger: "blur" }],
        // mono_happed: [{ required: true, message: "请输入初始计数", trigger: "blur" }],
        site_id: [
          {
            required: true,
            min: 1,
            type: "number",
            message: "请选择站点",
            trigger: "blur",
          },
        ],
        /* charge_id: [
          {
            required: true,
            type: "number",
            message: "请选择计费方案",
            trigger: "blur",
          },
        ], */
        /*  scene_id: [
          {
            required: true,
            type: "number",
            message: "请选择场景类型",
            trigger: "blur",
          },
        ], */
        support: [
          {
            validator: (rule, value, callback) => {
              if (value.length) {
                callback();
              } else {
                callback(new Error("至少勾选一项"));
              }
            },
            required: true,
            trigger: "blur",
          },
        ],
        // meter_charge_id: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (this.data.meter !== 2 && this.data.meter > 0) {
        //         if (this.data.meter_charge_id) {
        //           callback();
        //         } else {
        //           callback(new Error("请选择抄表结算方案"));
        //         }
        //       } else {
        //         callback();
        //       }
        //     },
        //     type: "number",
        //     trigger: "blur",
        //   },
        // ],
        // meter_charge_id1: [{ validator: (rule, value, callback)=>{
        //   if(this.data.meter === 1 && this.data.meter_charge_id){
        //     callback()
        //   }else{
        //     callback(new Error('请选择抄表结算方案'))
        //   }
        // }, required: true, trigger: 'blur'}],
        repair_ids: [
          {
            required: true,
            type: "array",
            message: "请选择维护人员",
            trigger: "select",
          },
        ],
        map: [{ validator: mapValidator, required: true }],
        dispense: [{ validator: dispenseValidator, required: true }],
      },
      old_repair_ids: [],
      type: [], // 设备型号
      support: ["游客", "会员", "打印", "复印", "扫描", "A3", "彩色", "冲印"],
      agent: [], // 代理商
      // base_company: [], // 未格式化学校数据
      company: [], // 学校
      // format_company: [], // 格式化学校id
      site: [], // 站点
      charge: [], // 计费方案
      repair: [], // 维护人员
      scene: [], // 场景类型
      map: false, //
      map_visible: false, // 地图模态框
      map_search: "", // 地图搜索
      service_visible: false, // 运营时间模态框
      meter_charge: [], // 抄表结算方案

      loaded: false,
      // meter_charge_show: false,

      status: "", //设备状态 用于status是否改变
      logoFile: {},
      logoChange: false, // 设备logo是否改变
      siteObj: {
        visible: false,
        name: "",
        agent_id: 0,
      }, // 站点新增
      repairObj: {
        visible: false,
        loading: false,
        rule: {
          name: [{ required: true, message: "未输入姓名", trigger: "blur" }],
          tel: [
            {
              required: true,
              type: "number",
              trigger: "blur",
              validator(rule, value, callback) {
                let reg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
                console.log(221, reg.test(value));
                if (!reg.test(value)) {
                  callback(new Error("请填写正确的手机号"));
                } else {
                  callback();
                }
              },
            },
          ],
        },
        current: {
          name: "",
          tel: "",
          agent_id: 0,
          gender: 1,
        },
      },
      companyAdd: {
        status: false,
      },
      modalVerify: {
        visible: false,
        isCode: false,
        tel: "",
        code: "",
        data: null,
      },
      verifiy: {
        verifiyBtnText: "获取验证码",
        verifiyTime: 0,
        timer: null,
      },
      modalDispense: {
        visible: false,
        sn: "",
        accounts: [],
        dispense: [],
        select: [],
        isRequset: true,
        data: {
          id: "", //设备ID
          agent_id: "", //代理商ID
          accoun_id: 0,
        },
      },
      machineDispenseParams: {
        visible: false,
        machine: {},
      },
      isExit: true, //是否离开当前页面
      old_agent_id: 0, //已设置的合作伙伴ID
      machine_id: 0,
    };
  },
  methods: {
    addAccount() {
      if (!this.modalDispense.data.accoun_id) {
        this.$Message.error("请选择收款人");
        return;
      }
      if (this.modalDispense.select.length == 5) {
        this.$Message.error("一个设备最多绑定5个收款人!");
        return;
      }
      let modalDispenseData = JSON.parse(JSON.stringify(this.modalDispense.data));
      let id = modalDispenseData.accoun_id;
      let data = {},
        flag = true;
      this.modalDispense.accounts.map((item) => {
        if (item.id === id) {
          data = { ...item };
        }
      });
      console.log("data", data);
      if ((data.open_id || data.user_id) && data.is_del === 0) {
        console.log("该收款账号为存在");
        this.modalDispense.dispense.map((item) => {
          if (item.dispense_account_id === id) {
            flag = false;
          }
        });
        if (flag) {
          let itemData = {
            name: data.name,
            machine_id: this.modalDispense.data.id,
            dispense_account_id: id,
            extract: "",
          };
          console.log("itemData", itemData);
          this.modalDispense.dispense.push(itemData);
          this.modalDispense.select.push(itemData);
          this.modalDispense.data.accoun_id = 0;
        } else {
          console.log("该收款账号已存在");
          this.$Message.error("该收款账号已存在");
        }
      } else {
        this.$Message.error("该收款账号未绑定收款方式");
      }
    },
    remove(data, index) {
      this.modalDispense.dispense.splice(index, 1);
      if (data.id) {
        // this.modalDispense.select[index].is_del = 1;
        this.modalDispense.select.map((item) => {
          if (item.id == data.id) item.is_del = 1;
        });
      } else {
        let d = JSON.parse(JSON.stringify(this.modalDispense.select));
        d.splice(index, 1);
        this.modalDispense.select = d;
      }
    },
    //保存分账设置
    saveDisppence(isSaveData) {
      try {
        let total = 0,
          dels = [],
          insert = [],
          update = [],
          count = 0;
        this.modalDispense.dispense.map((item) => {
          this.modalDispense.select.map((i) => {
            if (item.dispense_account_id == i.dispense_account_id) {
              i.extract = item.extract;
            }
          });
        });
        let status = true;
        console.log("this.modalDispense", this.modalDispense);
        this.modalDispense.select.map((item) => {
          if (!item.machine_id && this.modalDispense.data.id)
            item.machine_id = this.modalDispense.data.id;
          if (!item.is_del) {
            total += Number(item.extract);
            count++;
            if (
              (!parseInt(item.extract) ||
                parseInt(item.extract) < 1 ||
                parseInt(item.extract) > 100) &&
              status
            ) {
              this.$Message.error("保存失败,比例必须在1-100之间");
              status = false;
            }
          }

          if (item.id && item.is_del === 1) {
            dels.push(item.id);
          } else if (item.id) {
            update.push(item);
          } else {
            // delete item.name;
            insert.push(item);
          }
        });
        if (!status && (insert.length || update.length)) return false;
        insert.map((item) => {
          // delete item.name;
        });

        console.log("并列", count, insert, update, dels);

        if (count === 0) {
        } else if (total !== 100) {
          // && this.agent.tp === 1
          this.$Message.error("保存失败,比例总和必须为100");
          return;
        } else if (
          total > 100 &&
          this.agent.tp === 0 &&
          this.agent.id === this.modalDispense.data.agent_id
        ) {
          this.$Message.error("保存失败,比例总和不能超过100");
          return;
        } else if (
          total !== 100 &&
          this.agent.tp === 0 &&
          this.agent.id !== this.modalDispense.data.agent_id
        ) {
          this.$Message.error("保存失败,比例总和必须为100");
          return;
        }
        if (this.modalDispense.data.id) {
          this.SaveUserAgentDispense({
            machine_id: this.modalDispense.data.id,
            insert: insert,
            update: update,
            dels: dels,
          }).then((res) => {
            if (res.status) {
              this.$Message.success(res.msg);
              this.modalDispense.visible = false;
              this.modalDispense.isRequset = false;
              console.log("isSaveData", isSaveData);
              if (isSaveData) {
                this.$router.back(); //新增设备保存返回
              }
            } else {
              this.$Message.warning(res.msg);
              this.modalDispense.isRequset = false; //标记设置收款人失败
            }
          });
          //设置网络超时显示
          setTimeout(() => {
            if (this.isExit && this.modalDispense.isRequset) {
              this.$Message.error("收款人绑定失败，请重新操作!");
              this.getData();
            }
          }, 5 * 1000); //5秒
        } else {
          this.modalDispense.visible = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    shopModalDispense() {
      if (this.data.settle_type === 1) {
        this.machineDispenseParams.machine = this.data;
        this.machineDispenseParams.visible = true;
        return false;
      }
      this.modalDispense.data.id = this.data.id || 0;
      this.modalDispense.data.agent_id = this.data.agent_id || 0;
      this.modalDispense.sn = this.data.sn || 0;
      let that = this;
      this.GetPayee({ l: 1000, agent_id: this.data.agent_id }).then((res) => {
        that.modalDispense.accounts = res.data;
        if (this.data.id) {
          that.GetUserAgentDispense({ id: this.data.id }).then((result) => {
            that.modalDispense.dispense = result;
            that.modalDispense.select = JSON.parse(JSON.stringify(result));
            that.modalDispense.visible = true;
          });
        } else {
          that.modalDispense.visible = true;
        }
      });
    },
    showDispense() {
      //测试
      this.shopModalDispense();
      return false;

      if (this.cacheGet("dispense_verify")) {
        this.shopModalDispense();
      } else {
        this.modalVerify.visible = true;
        this.modalVerify.tel =
          this.user.leader_tel.substr(0, 3) + "****" + this.user.leader_tel.substr(7);
        // this.modalVerify.data = data.row;
      }
    },
    initDispense() {
      this.modalDispense.data.id = this.$route.params.id;
      this.GetUserAgentDispense({ id: this.$route.params.id }).then((result) => {
        console.log("initDispense", result);
        this.modalDispense.dispense = result;
        this.modalDispense.select = JSON.parse(JSON.stringify(result));
      });
    },
    getCode() {
      if (this.user.leader_tel) {
        if (this.verifiy.time) return false;
        this.SendTelCode({ tel: this.user.leader_tel, type: 2 }).then((res) => {
          this.$Message[res.status ? "success" : "error"](res.msg);
          if (res.status) {
            this.modalVerify.isCode = true;

            this.verifiy.time = 60;
            this.verifiy.timer = setInterval(() => {
              if (this.verifiy.time) {
                this.verifiy.time--;
                this.verifiy.verifiyBtnText = `${this.verifiy.time}S`;
              } else {
                this.verifiy.time = 0;
                this.verifiy.verifiyBtnText = "";
                clearInterval(this.verifiy.timer);
              }
            }, 1000);
          }
        });
      } else {
        this.$Message.error("请绑定负责人手机号！");
      }
    },
    confirmVerify() {
      if (this.modalVerify.code) {
        this.CodeCheck({
          agent_id: this.user.id,
          tel: this.user.leader_tel,
          code: this.modalVerify.code,
        }).then((res) => {
          if (res.status) {
            //验证通过
            //设置验证失效时间(10分钟)
            this.cacheSet("dispense_verify", "true", 1440 * 60);

            this.shopModalDispense();
            this.modalVerify.isNext = true;
            this.modalVerify.code = "";
            this.modalVerify.visible = false;
            //取消倒计时
            this.verifiy.time = 0;

            this.verifiy.verifiyBtnText = `获取验证码`;
            clearInterval(this.verifiy.timer);
          } else {
            this.$Message["error"](res.msg);
          }
        });
      } else {
        this.$Message.error("请正确填入验证码");
      }
    },
    cacheSet(key, value = "", expire = 0) {
      // 当前时间戳
      let nowTime = Math.ceil(Date.now() / 1000);
      // 设置数据
      localStorage.setItem(key, JSON.stringify(value));
      // 判断是否有过期时间
      if (expire > 0) {
        // 设置过期时间
        localStorage.setItem(key + "_expire", nowTime + parseInt(expire));
      } else {
        // 设置过期时间
        localStorage.setItem(key + "_expire", 0);
      }
      return true;
    },
    /**
     * 读取 localStoryage
     * @param key
     * @return bool|originData false|originData
     */
    cacheGet(key) {
      // 当前时间戳
      let nowTime = Math.ceil(Date.now() / 1000);
      // 获取键时间戳
      let rawCacheDataExpire = localStorage.getItem(key + "_expire");
      let cacheDataExpire = parseInt(rawCacheDataExpire);

      // 强制过期时间 为0时忽略 用于解决缓存时间与本地时间差距过大(例本地更改了计算机时间)
      let forceTime = 3600;
      // 判断用户是否删除了过期时间 判断是否设置了过期时间 判断是否超过过期时间 判断当前计算机时间与设置的过期时间差距是否过大
      if (
        rawCacheDataExpire === null ||
        (cacheDataExpire > 0 && nowTime > cacheDataExpire)
      ) {
        // 删除过期key
        localStorage.removeItem(key);
        // 删除过期时间
        localStorage.removeItem(key + "_expire");
        return false;
      }
      // 获取数据
      let cacheData = JSON.parse(localStorage.getItem(key));

      if (cacheData === null || cacheData === false) {
        return false;
      }
      // 返回数据
      return cacheData;
    },
    //创建学校
    AddCompanyCall(e) {
      this.companyAdd.status = false;
      if (e) {
        this.getCompany({
          p: 0,
          l: 1000,
          is_del: 0,
          // cond: "type",
          // value: 0
        }).then((res) => {
          this.company = res.data;
          console.log("设备数据", this.data);
          this.data.company_id = e;
        });
      }
    },
    new_company(e) {
      this.companyAdd.status = true;
    },
    //创建维护人员
    newRepair() {
      this.repairObj.current = {
        name: "",
        tel: "",
        agent_id: 0,
        gender: 1,
      };
      this.repairObj.visible = true;
    },
    saveRepairs() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.repairObj.loading = true;
          let data = JSON.parse(JSON.stringify(this.repairObj.current));
          delete data._index;
          delete data._rowKey;
          delete data.agent_name;
          delete data.count;
          if (!data.agent_id) {
            delete data.agent_id;
          }
          this.saveRepair(data).then((res) => {
            this.repairObj.loading = false;
            if (res.status) {
              this.repairObj.visible = false;
              if (res.id) {
                this.repairObj.current.id = res;
              }
              this.$Message.success("新增成功，需要维护人员通过微信公众号激活后才可使用");
              this.getRepair({
                p: 0,
                l: 1000,
                is_del: 0,
                openidStatus: 1,
              }).then((result) => {
                this.repair = result.data;
                this.data.repair_ids.push(res.id);
              });
            } else {
              this.$Message.error("该用户已存在");
            }
          });
        }
      });
    },
    // 创建站点
    newSite() {
      this.siteObj = {
        visible: true,
        name: "",
        agent_id: 0,
      };
    },
    // 保存站点
    saveSiteObj() {
      this.saveSite({
        name: this.siteObj.name,
        agent_id: this.siteObj.agent_id,
      }).then((res) => {
        this.siteObj.visible = false;
        this.site.push(res);
        this.data.site_id = res.id;
      });
    },
    // 选择图片
    choose(e, type) {
      let file = e.target.files[0];
      if (file) {
        if (file.type !== "image/png") {
          this.$Message.error("仅支持png图片");
          return;
        }
        this.logoFile = file;
        let temp = file.name.split(".");
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          this.data.logo = e.currentTarget.result;
          this.logoChange = true;
        };
      }
    },
    // // 控制抄表结算方案
    // handleMeterCharge() {
    //   this.meter_charge_show = !this.meter_charge_show;
    //   if (this.meter_charge_show) {
    //     this.data.meter_date = 1;
    //   } else {
    //     this.data.meter_date = 0;
    //   }
    // },
    // 设置终端软件类型
    setMeter(val) {
      if (val === 3) {
        this.$Message.warning("即将推出");
        return;
      }
      this.data.meter = val;
    },
    serviceModalOk() {
      this.data.service_mon = this.service_mon.join("-");
      this.data.service_tues = this.service_tues.join("-");
      this.data.service_wed = this.service_wed.join("-");
      this.data.service_thur = this.service_thur.join("-");
      this.data.service_fri = this.service_fri.join("-");
      this.data.service_sat = this.service_sat.join("-");
      this.data.service_sun = this.service_sun.join("-");
    },
    mapModalOk() {
      this.data.lng = this.lng;
      this.data.lat = this.lat;
    },
    // 搜索地址并添加覆盖物
    setPoint() {
      let myGeo = new BMap.Geocoder();
      myGeo.getPoint(
        this.map_search,
        (point) => {
          if (point) {
            // 删除覆盖物
            this.map.clearOverlays();
            this.map.centerAndZoom(point, 14);
            this.map.addOverlay(new BMap.Marker(point));
            this.lng = point.lng;
            this.lat = point.lat;
          } else {
            this.$Message.warning("未找到地址,请再详细一点");
          }
        },
        "中国"
      );
    },
    // 打开地图模态框
    openMap() {
      this.map_visible = true;
      this.map = new BMap.Map(this.$refs.map);
      // 允许鼠标滑轮
      this.map.enableScrollWheelZoom();
      // 设置地图默认中心点
      if (this.data.al.length == 3 && this.data.address) {
        // 使用城市名
        let address =
          this.data.al[0] + this.data.al[1] + this.data.al[2] + this.data.address;
        this.map.centerAndZoom(address, 14);
      } else if (this.data.lng && this.data.lat) {
        // 使用 this.data
        setTimeout(() => {
          let point = new BMap.Point(this.data.lng, this.data.lat);
          let marker = new BMap.Marker(point);
          this.map.addOverlay(marker);
          this.map.centerAndZoom(point, 16);
        }, 100);
      } else {
        // 使用ip当前地址
        let myCity = new BMap.LocalCity();
        myCity.get((result) => {
          this.map.centerAndZoom(result.name, 14);
        });
      }
      let geoc = new BMap.Geocoder();
      this.map.addEventListener("click", (e) => {
        // 删除覆盖物
        this.map.clearOverlays();
        let marker = new BMap.Marker(e.point);
        this.map.addOverlay(marker);
        this.lng = e.point.lng;
        this.lat = e.point.lat;
        geoc.getLocation(e.point, (res) => {
          this.map_search = res.address;
        });
      });
    },
    saveData() {
      let data = JSON.parse(JSON.stringify(this.data));
      data.repair_ids = this.data.repair_ids.join(",");

      console.log("维护人员ID", this.old_repair_ids);
      //判断是否删除之前已关联的维护人员
      let removeIds = this.old_repair_ids.filter(
        (item) => !data.repair_ids.includes(item)
      );
      if (removeIds.length > 0) {
        data.remove_repair = removeIds.join(",");
        console.log("删除的维护人员ID", data.remove_repair);
      }
      // let isActive = 0;
      //判断选择的维护人员是否激活
      /* this.repair.map((item) => {
        if (item.id == data.repair_ids && !item.gzh_openid) {
          isActive = 1;
          this.data.repair_ids = '';
        }
      });
      if (isActive == 1) {
        this.$Message.error("选择的维护人员未激活!");
        this.$refs["formInline1"].validate((valid) => {

        });
        this.loading = false;
        return;
      } */

      if (data.support) {
        data.support = data.support.join(",");
      }
      if (data.functions) {
        let temp = [];
        data.functions.map((item) => {
          if (item) {
            temp.push(item);
          }
        });
        data.functions = temp.join(",");
      }
      data.province = data.al[0];
      data.city = data.al[1];
      data.area = data.al[2];
      if (data.company_id === 0) {
        data.company_id = null;
      }
      if (data.meter_charge_id === 0) {
        data.meter_charge_id = null;
      }
      // data.company_id = this.format_company[this.format_company.length - 1]
      delete data.al;
      delete data.agent_tp;
      delete data.agent_name;
      delete data.company_name;
      delete data.charge_name;
      delete data.meter_charge_name;
      delete data.repair_name;
      delete data.site_name;
      delete data.machine_type_name;
      delete data.machine_activity_id;
      delete data.machine_activity_name;
      delete data.ad_name;
      delete data.error;
      delete data.scene_name;
      delete data.repair_tel;
      // delete data.expire_time;
      // delete data.trail_expire_time;
      delete data.create_time;
      delete data.service_time;
      delete data.active_time;
      delete data.agent_service_tel;
      delete data.settle_type;
      switch (data.meter) {
        case 0: //云知印
          //--使用限制
          //游客
          data.tourist = { print: 0, copy: 0, color: 0 };
          this.checkAllGroup1.map((item) => {
            data.tourist[item] = 1;
          });
          //会员
          data.member = { print: 0, copy: 0, scan: 0, color: 0 };
          this.checkAllGroup2.map((item) => {
            data.member[item] = 1;
          });
          //会员（学校员工）
          data.staff = { print: 0, copy: 0, scan: 0, color: 0, scanPay: 0 };
          this.checkAllGroup3.map((item) => {
            data.staff[item] = 1;
          });
          console.log("学校员工", data.staff);
          if (this.isCoupon) {
            data.coupon = 1;
          } else {
            data.coupon = 0;
          }
          if (this.isSelfStaff) {
            data.self_staff = 1;
          } else {
            data.self_staff = 0;
          }
          if (this.isOpenList) {
            data.is_open_list = 1;
          } else {
            data.is_open_list = 0;
          }
          if (this.isScanPay) {
            data.staff.scanPay = 1;
          } else {
            data.staff.scanPay = 0;
          }
          break;
        case 1:
          data.support = null;
          // data.site_id = null;
          data.charge_id = null;
          // data.repair_id = null;
          data.is_share = 0;
          data.lng = null;
          data.lat = null;
          data.service_tel = null;
          data.logo = null;
          break;
        case 2:
          data.support = null;
          // data.site_id = null;
          data.charge_id = null;
          data.meter_charge_id = null;
          // data.repair_id = null;
          data.is_share = 0;
          data.lng = null;
          data.lat = null;
          data.service_tel = null;
          data.logo = null;
          data.scene_id = null;
          break;
        default:
          break;
      }
      console.log("data", data);
      /* if (!data.id) {
        if (
          data.mono_happed === "" ||
          data.mono_happed === null ||
          data.mono_happed < 0 ||
          data.color_happend === "" ||
          data.color_happend === null ||
          data.color_happend < 0
        ) {
          this.$Message.error("请填写正确的初始数据");
          this.loading = false;
          return;
        }
      }else if(
          data.mono_happed === "" ||
          data.mono_happed === null ||
          data.color_happend === "" ||
          data.color_happend === null
        ) {
          this.$Message.error("请填写正确的初始数据");
          this.loading = false;
          return;
        } */

      if (
        data.mono_happed === "" ||
        data.mono_happed === null ||
        data.mono_happed < 0 ||
        data.color_happend === "" ||
        data.color_happend === null ||
        data.color_happend < 0
      ) {
        this.$Message.error("请填写正确的初始数据");
        this.loading = false;
        return;
      }

      this.saveMachine(data).then(async (res) => {
        this.loading = false;
        if (res.status) {
          this.data.id = res.id;
          this.machine_id = res.id;
          this.$Message.success("操作成功");
          await this.SyncMachine();
          this.$router.back();

          /*  if (!this.modalDispense.data.id) {
            this.modalDispense.data.id = res.id;
            // this.saveDisppence(true);
          } else {
            this.$router.back();
          } */
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    handleSubmit() {
      try {
        let success = false,
          formInline2 = true,
          formInline5 = true;
        console.log("this.data.meter", this.data.meter);
        this.$refs["formInline1"].validate((valid) => {
          success = valid;
        });
        /*  if (this.data.meter == 0) {
          this.$refs["formInline2"].validate((valid) => {
            formInline2 = valid;
          });
        } */
        /* if (this.data.meter == 0) {
          this.$refs["formInline5"].validate((valid) => {
            formInline5 = valid;
          });
        } */
        console.log("success", success, formInline2, formInline5);
        if (!success || !formInline5) {
          this.$Message.error("请完成红色必填项");
          return false;
        }
        if (success) {
          this.loading = true;
          if (this.logoChange) {
            let formData = new FormData();
            formData.append("file", this.logoFile, "temp.png");
            this.SaveLogo(formData).then((res) => {
              this.data.logo = res;
              this.saveData();
            });
          } else {
            this.saveData();
          }
          if (this.logoChange || this.service_tel !== this.data.service_tel) {
            this.socketSend({
              action: 10006,
              value: {
                sn: this.data.sn,
                logo: this.data.logo,
                service_tel: this.data.service_tel,
              },
            });
          }
        } else {
          console.log("验证失败");
        }
      } catch (error) {
        console.log(error);
      }
    },
    editMachine(data) {
      data.id = this.data.id;
      console.log("点击了");
      if (data.status == 1 || data.status == 2) {
        let str = data.status == 2 ? "删除" : "禁用";
        this.$Modal.confirm({
          title: "重要提示",
          content: `确定` + str + `此设备吗？`,
          onOk: () => {
            this.saveMachine(data).then((res) => {
              this.$Message.success("操作成功");
              if (data.status !== this.status) {
                console.log("status 改变", this.data.id, this.data.sn, data.status);
                this.socketSend({
                  action: 10003,
                  value: {
                    id: this.data.id,
                    sn: this.data.sn,
                    status: data.status,
                  },
                });
              }
              this.$router.back();
            });
          },
        });
      } else {
        this.saveMachine(data).then((res) => {
          this.$Message.success("操作成功");
          if (data.status !== this.status) {
            console.log("status 改变", this.data.id, this.data.sn, data.status);
            this.socketSend({
              action: 10003,
              value: {
                id: this.data.id,
                sn: this.data.sn,
                status: data.status,
              },
            });
          }
          this.$router.back();
        });
      }
    },
    getData() {
      this.machineInfo({ id: this.machine_id }).then((res) => {
        res.al = [res.province, res.city, res.area];
        this.status = JSON.parse(JSON.stringify(res)).status;
        this.service_tel = JSON.parse(JSON.stringify(res)).service_tel;
        res.member = res.member
          ? JSON.parse(res.member)
          : { print: 1, copy: 1, scan: 1, color: 1 };
        res.staff = res.staff
          ? JSON.parse(res.staff)
          : { print: 1, copy: 1, scan: 1, color: 1 };
        res.tourist = res.tourist
          ? JSON.parse(res.tourist)
          : { print: 0, copy: 0, color: 0 };

        if (res.staff.scanPay == 1) {
          this.isScanPay = true;
        }

        this.checkAllGroup1 = [];
        this.checkAllGroup2 = [];
        this.checkAllGroup3 = [];
        for (let key in res.tourist) {
          if (res.tourist[key] == 1) {
            this.checkAllGroup1.push(key);
          }
        }
        for (let key in res.member) {
          if (res.member[key] == 1) {
            this.checkAllGroup2.push(key);
          }
        }
        for (let key in res.staff) {
          if (res.staff[key] == 1) {
            this.checkAllGroup3.push(key);
          }
        }
        if (this.checkAllGroup1.length < 3) {
          this.checkAll1 = false;
          this.indeterminate1 = true;
        } else if (this.checkAllGroup1.length == 0) {
          this.checkAll1 = false;
          this.indeterminate1 = false;
        }
        if (this.checkAllGroup2.length < 4) {
          this.checkAll2 = false;
          this.indeterminate2 = true;
        } else if (this.checkAllGroup2.length == 0) {
          this.checkAll2 = false;
          this.indeterminate2 = false;
        }
        if (this.checkAllGroup3.length < 4) {
          this.checkAll3 = false;
          this.indeterminate3 = true;
        } else if (this.checkAllGroup3.length == 0) {
          this.checkAll3 = false;
          this.indeterminate3 = false;
        }
        this.isCoupon = res.coupon == 1;
        this.isSelfStaff = res.self_staff == 1;
        this.isOpenList = res.is_open_list == 1;

        res.support = res.support ? res.support.split(",") : [];
        res.functions = res.functions ? res.functions.split(",") : [];
        this.lng = res.lng;
        this.lat = res.lat;
        if (res.meter_charge_id) {
          this.meter_date = true;
        }
        this.old_repair_ids = res.repair_ids.split(",");
        res.repair_ids = res.repair_ids
          ? res.repair_ids.split(",").map((item) => {
              return parseInt(item);
            })
          : [];
        console.log("resres", res);
        this.data = JSON.parse(JSON.stringify(res));
        this.old_agent_id = this.data.agent_id;
        this.initDispense();
        this.loaded = false;
      });
    },
    // 验证加载合作伙伴权限
    agentAccess() {
      return hasOneOf(["0"], this.access);
    },

    handleCheckAll(index) {
      if (this.user.tp) return false;
      switch (index) {
        case 1:
          if (this.indeterminate1) {
            this.checkAll1 = false;
          } else {
            this.checkAll1 = !this.checkAll1;
          }
          this.indeterminate1 = false;
          if (this.checkAll1) {
            this.checkAllGroup1 = ["print", "copy", "color"];
          } else {
            this.checkAllGroup1 = [];
          }
          break;
        case 2:
          if (this.indeterminate2) {
            this.checkAll2 = false;
          } else {
            this.checkAll2 = !this.checkAll2;
          }
          this.indeterminate2 = false;
          if (this.checkAll2) {
            this.checkAllGroup2 = ["print", "copy", "scan", "color"];
          } else {
            this.checkAllGroup2 = [];
          }
          break;
        case 3:
          if (this.indeterminate3) {
            this.checkAll3 = false;
          } else {
            this.checkAll3 = !this.checkAll3;
          }
          this.indeterminate3 = false;
          if (this.checkAll3) {
            this.checkAllGroup3 = ["print", "copy", "scan", "color"];
          } else {
            this.checkAllGroup3 = [];
          }
          break;
      }
    },
    checkAllGroupChange(index) {
      switch (index) {
        case 1:
          if (this.checkAllGroup1.length === 3) {
            this.indeterminate1 = false;
            this.checkAll1 = true;
          } else if (this.checkAllGroup1.length > 0) {
            this.indeterminate1 = true;
            this.checkAll1 = false;
          } else {
            this.indeterminate1 = false;
            this.checkAll1 = false;
          }
          break;
        case 2:
          if (this.checkAllGroup2.length === 4) {
            this.indeterminate2 = false;
            this.checkAll2 = true;
          } else if (this.checkAllGroup2.length > 0) {
            this.indeterminate2 = true;
            this.checkAll2 = false;
          } else {
            this.indeterminate2 = false;
            this.checkAll2 = false;
          }
          break;
        case 3:
          if (this.checkAllGroup3.length === 4) {
            this.indeterminate3 = false;
            this.checkAll3 = true;
          } else if (this.checkAllGroup3.length > 0) {
            this.indeterminate3 = true;
            this.checkAll3 = false;
          } else {
            this.indeterminate3 = false;
            this.checkAll3 = false;
          }
          break;
      }
    },
    agentChange() {
      console.log("更换", this.old_agent_id);
      if (this.old_agent_id !== 0 && this.data.agent_id != this.old_agent_id) {
        this.modalDispense.select = [];
        this.data.repair_ids = [];
      }
    },
    cancelBtn() {
      console.log("设备", this.modalDispense.accounts);
      /* if (this.isExit && this.modalDispense.isRequset && this.modalDispense.select.length>0) {
        this.$Message.error('收款人绑定失败，请重新操作!');
      } */
      this.$router.back();
    },
    ...mapActions([
      "getType",
      "getAgentList",
      "getCompany",
      "getSite",
      "getCharge",
      "GetScene",
      "getRepair",
      "GetMeterCharge",
      "saveMachine",
      "machineInfo",
      "socketSend",
      "SaveLogo",
      "saveSite",
      "saveRepair",
      "CodeCheck",
      "SendTelCode",
      "GetPayee",
      "GetUserAgentDispense",
      "SaveUserAgentDispense",
      "SyncMachine",
    ]),
  },
  beforeMount() {},
  mounted() {
    this.machine_id = this.$route.params.id;
    if (!this.machine_id) {
      this.data.mono_happed = 0;
      this.data.color_happed = 0;
    }
    // 默认合作伙伴自营为登录者
    this.data.agent_id = this.user.id;
    // 设备型号
    this.getType().then((res) => {
      this.type = res;
    });
    // 合作伙伴 运营商时获取
    if (!this.user.tp) {
      this.getAgentList({ p: 0, l: 1000, is_del: 0 }).then((res) => {
        this.agent = res.data;
      });
    }
    // 学校
    //, cond: "type", value: 0
    this.getCompany({ p: 0, l: 1000, is_del: 0 }).then((res) => {
      // this.base_company = JSON.parse(JSON.stringify(res.data))
      // res.data.map(item => {
      //   item.label = item.company_name
      //   item.value = item.id
      // })
      // res.data.map(item => {
      //   if (!item.parent_id) {
      //     item.children = []
      //   }
      //   res.data.map((it, index) => {
      //     if (item.id === it.parent_id) {
      //       console.log(419,item)
      //       item.children.push(it)
      //       res.data.splice(index, 1)
      //     }
      //   })
      // })
      this.company = res.data;
    });
    // 站点
    this.getSite({ p: 0, l: 1000, is_del: 0 }).then((res) => {
      this.site = res.data;
    });
    // 计费方案
    /* this.getCharge({ p: 0, l: 1000, is_del: 0 }).then((res) => {
      this.charge = res.data;
    }); */

    // 抄表结算方案
    /*  this.GetMeterCharge({ p: 0, l: 1000, is_del: 0 }).then((res) => {
      this.meter_charge = res.data;
    }); */
    /* this.GetScene().then((res) => {
      this.scene = res;
    }); */
    // 维护人员
    if (this.$route.params.id) {
      this.loaded = true;
    }
    this.getRepair({ p: 0, l: 1000, is_del: 0 }).then((res) => {
      this.repair = res.data;
      if (this.$route.params.id) {
        this.getData();
      }
    });
  },
  deactivated() {
    console.log("离开当前页面");
    this.isExit = false;
  },
  computed: mapGetters({
    user: "agent",
    access: "access",
  }),
  watch: {
    "data.agent_id"(n, o) {
      if (this.loaded) {
        // this.data.company_id = 0;
        // this.data.site_id = 0;
        console.log("watch_data.agent_id");
      }
    },
    "data.meter"(n, o) {
      if (n) {
        // this.data.company_id = 0;
        console.log("watch_data.meter");
      }
    },
    service_visible(n, o) {
      console.log("this.data", this.data);
      const {
        service_mon,
        service_tues,
        service_wed,
        service_thur,
        service_fri,
        service_sat,
        service_sun,
      } = this.data;
      this.service_mon = service_mon.split("-");
      this.service_tues = service_tues.split("-");
      this.service_wed = service_wed.split("-");
      this.service_thur = service_thur.split("-");
      this.service_fri = service_fri.split("-");
      this.service_sat = service_sat.split("-");
      this.service_sun = service_sun.split("-");
    },
  },
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
